//此对象暂时未启用
const count = {
  enterTime: 160,
  newWindowTime: 500,
  otherWindowDisplayTime: 12000,
  storageInputValueCount: 100,
  storageSongCount: 20,
  handleInputTime: 1200,
  playQQMusicWindowWidth: 1080,
  playQQMusicWindowHeight: 720,
}
export default count



// WEBPACK FOOTER //
// ./src/cnConst/count.js